import { createContext, useContext, useEffect, useState } from "react";
import {
  fetchAllBrands,
  fetchAllCategories,
} from "../apiServices/categoriesServices"; // Adjust the import path if needed

const NavbarCategoriesContext = createContext();

export const NavbarCategoriesProvider = ({ children }) => {
  const [categories, setCategories] = useState([]);
  const [brands, setBrands] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedCategoryId, setSelectedCategoryId] = useState(null);

  useEffect(() => {
    const getCategories = async () => {
      try {
        const data = await fetchAllCategories();
        // console.log("categories data: ", data);
        setCategories(data);
      } catch (err) {
        setError("Failed to load categories");
      } finally {
        setLoading(false);
      }
    };

    const getBrands = async () => {
      try {
        const data = await fetchAllBrands();
        console.log("brands data: ", data);
        setBrands(data);
      } catch (err) {
        setError("Failed to load categories");
      } finally {
        setLoading(false);
      }
    };

    getCategories();
    getBrands();
  }, []);

  const selectCategory = (categoryId) => {
    setSelectedCategoryId(categoryId);
  };

  return (
    <NavbarCategoriesContext.Provider
      value={{
        categories,
        brands,
        loading,
        error,
        selectedCategoryId,
        selectCategory,
      }}
    >
      {children}
    </NavbarCategoriesContext.Provider>
  );
};

export const useNavbarCategories = () => {
  return useContext(NavbarCategoriesContext);
};
